module.exports = __webpack_public_path__ + "img/logo2.f54fa724.png";